<template>
  <div v-title title="资料填写">
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表单1 -->
  <el-form ref="form" :model="form" label-width="80px" >
    <el-row>
        <el-col :span="36">
            <el-form-item label-width="150px" class="hang" label="所属地区" >
                <el-select
                        style="width: 20%;margin-right: 1%"
                        v-model="form.province"
                        placeholder="省"
                        @change="changeDept($event,0)"
                >
                    <el-option
                            v-for="item in provinceArry"
                            :key="item.deptId"
                            :label="item.deptName"
                            :value="item.deptId"
                    ></el-option>
                </el-select>
                <el-select
                        style="width: 20%;margin-right:1%"
                        class="center_select"
                        v-model="form.city"
                        placeholder="市"
                        @change="changeDept($event,1)"
                >
                    <el-option
                            v-for="item in cityArry"
                            :key="item.deptId"
                            :label="item.deptName"
                            :value="item.deptId"
                    ></el-option>
                </el-select>
                <el-select
                        style="width: 20%;"
                        v-model="form.district"
                        placeholder="区"
                        @change="changeDept($event,2)"
                >
                    <el-option
                            v-for="item in districtArry"
                            :key="item.deptId"
                            :label="item.deptName"
                            :value="item.deptId"
                    ></el-option>
                </el-select>
                <span class="xing">*</span><span class="bei">请输入机构所属地区</span>
            </el-form-item>
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label-width="150px" class="hang" label="机构名称" prop="orgName">
          <el-input class="inputs" v-model="form.orgName"  :maxlength="30" />
          <span class="xing">*</span><span class="bei">请输入机构名称</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" >
        <el-form-item label-width="150px" class="hang" label="经营地址" prop="detailAddress">
          <el-input class="inputs" v-model="form.detailAddress"  :maxlength="100"/>
          <span class="xing">*</span><span class="bei">请输入机构经营地址</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="成立时间" prop="establishDate">
              <el-date-picker
                      type="date"
                      v-model="form.establishDate"
                      placeholder=" "
                      value-format="YYYY-MM-DD"
                      :disabledDate="pickerOptions"
                      style="width: 41.5%"
              />
              <span class="xing">*</span><span class="bei">请选择成立时间</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="注册类型" prop="registryType">
              <el-select class="selects" v-model="form.registryType" placeholder=" " @change="changeRegistryType">
                  <el-option
                          v-for="item in registryTypeArr"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                  ></el-option>
              </el-select>
              <span class="xing">*</span><span class="bei">请选择注册类型</span>
          </el-form-item>
      </el-col>
      <el-col :span="24" >
          <el-form-item label-width="150px" class="hang" label="机构负责人" prop="orgHeader">
              <el-input class="inputs" v-model="form.orgHeader"  :maxlength="30"/>
              <span class="xing">*</span><span class="bei">请输入机构负责人姓名</span>
          </el-form-item>
      </el-col>
      <el-col :span="24" >
          <el-form-item label-width="150px" class="hang" label="联系方式" prop="orgPhone">
              <el-input class="inputs" v-model="form.orgPhone"  :maxlength="11" @blur="checkPhoneNumber"/>
              <span class="xing">*</span><span class="bei">请输入机构负责人手机号码</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="培训项目" prop="trainProgramId">
              <el-select class="selects" multiple clearable  @change="$forceUpdate()" v-model="form.trainProgramIdForm" placeholder=" " >
                  <el-option
                          v-for="item in trainProgramList"
                          :key="item.id"
                          :label="item.trainProgramName"
                          :value="item.id"
                  ></el-option>
              </el-select>
              <span class="xing">*</span><span class="bei">请选择培训项目<span class="xing">（可多选）</span></span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="是否有办学许可证" prop="schoolLicense">
              <el-select class="selects" v-model="form.schoolLicense" placeholder=" " @change="changeSchoolLicense">
                  <el-option
                          v-for="item in schoolLicenseArr"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                  ></el-option>
              </el-select>
              <span class="xing">*</span><span class="bei">请选择是否有办学许可证</span>
          </el-form-item>
      </el-col>
      <el-col :span="24" >
          <el-form-item label-width="150px" class="hang" label="会员人数" prop="memberNum">
              <el-input onkeyup="this.value = this.value.replace(/[^\d]/g,'');" class="inputs" v-model="form.memberNum"  :maxlength="8"/>
              <span class="xing">*</span><span class="bei">请输入会员人数</span>
          </el-form-item>
      </el-col>
      <el-col :span="24" >
          <el-form-item label-width="150px" class="hang" label="教练人数" prop="coachNum">
              <el-input onkeyup="this.value = this.value.replace(/[^\d]/g,'');" class="inputs" v-model="form.coachNum" :maxlength="5"/>
              <span class="xing">*</span><span class="bei">请输入教练人数</span>
          </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="150px" class="hang" label="培训场地类型" prop="trainPlaceType">
          <el-select class="selects" v-model="form.trainPlaceType" placeholder=" " @change="changeTrainPlaceType">
            <el-option
                v-for="item in trainPlaceTypeArr"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请选择培训场地类型</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="150px" class="hang" label="机构总面积(㎡)" prop="orgArea">
          <el-input oninput="value=value.replace(/[^0-9.]/g,'')" class="inputs" v-model="form.orgArea"  :maxlength="8"/>
          <span class="xing">*</span><span class="bei">请输入机构总面积</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="备注" prop="remark">
              <el-input type="textarea" class="inputs" v-model="form.remark"  :autosize="{minRows:5,maxRows:50}" :maxlength="500"/>
              <span class="xing"></span><span class="bei">请输入备注</span>
          </el-form-item>
      </el-col>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons2" size="mini" @click="submit">提交</div>
    </el-row>
  </el-form>
  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>

import {
  getDeptList,
  getRegistryTypeList,
  getSchoolLicenseList,
  getTrainProgramList,
  getTrainPlaceTypeList,
  saveOrgInfo
} from "@/requst/api";
import {ElMessage} from "element-plus";

export default {
  name: 'TianBao',
  data() {
    return {
      // 区域树选项
      deptOptions: undefined,
      form: {
          establishDate: null,
          orgArea: null
      },
      //注册类型
      registryTypeArr:[],
      //培训项目
      trainProgramList:[],
      //是否有办学许可证
      schoolLicenseArr: [],
      //培训场地类型
      trainPlaceTypeArr: [],
      provinceArry: {},
      cityArry: {},
      districtArry: {},
    }
  },


  created() {
    //所属城市列表
    this.getProvinceList(0);
    //注册类型下拉选项
    this.getRegistryTypeList();
    //是否有办学许可证
    this.getSchoolLicenseList();
    //培训项目
    this.getTrainProgramList();
    //培训场地类型
    this.getTrainPlaceTypeList();
  },
  methods: {
      pickerOptions(time) {
          return time.getTime() > Date.now();
      },
      proving(params) {
          this.form.memberNnum = params.match(/\d+(\.\d{0,2})?/) ? params.match(/\d+(\.\d{0,2})?/)[0] : '';

      },

      checkPhoneNumber() {
          const phoneReg = /^1[3456789]\d{9}$/
          if (!phoneReg.test(this.form.orgPhone)) {
              ElMessage.error('联系方式格式错误')
              return false;
          }
      },
    /** 查询省下拉树结构 */
    getProvinceList(deptId) {
         let queryParams ={
             parentId : deptId
         }
        getDeptList(queryParams).then(response => {
            this.provinceArry = response.data;
        });
    },
    /** 查询市下拉树结构 */
    getCityList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.cityArry = response.data;
        });
    },
    /** 查询区下拉树结构 */
    getDistrictList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.districtArry = response.data;
        });
    },
    changeDept(data, type){
        //省下拉框改变
        if (type == 0) {
            this.getCityList(data);
        }
        //市下拉框改变
        if (type == 1) {
            this.getDistrictList(data);
            this.form.deptId = data;
        }
        //区下拉框改变
        if (type == 2) {
            this.form.deptId = data;
        }
    },
    //注册类型下拉选项
    getRegistryTypeList(){
        getRegistryTypeList().then(response => {
            this.registryTypeArr = response.data;
        });
    },
   //是否有办学许可证
    getSchoolLicenseList(){
        getSchoolLicenseList().then(response => {
            this.schoolLicenseArr = response.data;
        });
    },
    //培训新项目下拉选项
    getTrainProgramList(){
        getTrainProgramList().then(response => {
            this.trainProgramList = response.rows;
        });
    },
    //培训场地类型下拉选项
    getTrainPlaceTypeList(){
        getTrainPlaceTypeList().then(response => {
            this.trainPlaceTypeArr = response.data;
        });
    },
    //机构注册类型
    changeRegistryType(value){
        this.form.registryType = value
    },
    //是否有办学许可证
    changeSchoolLicense(value){
        this.form.schoolLicense = value
    },
    //培训场地类型
    changeTrainPlaceType(value){
        this.form.trainPlaceType = value
    },
    //提交保存
    submit(){
        if (!this.form.deptId) {
            ElMessage.error('请选择所属地区')
            return false;
        }
        if (!this.form.orgName) {
            ElMessage.error('请输入机构名称')
            return false;
        }
        if (!this.form.detailAddress) {
            ElMessage.error('请输入经营地址')
            return false;
        }
        if (!this.form.establishDate) {
            ElMessage.error('请选择成立时间')
            return false;
        }
        if (!this.form.registryType) {
            ElMessage.error('请选择注册类型')
            return false;
        }
        if (!this.form.orgHeader) {
            ElMessage.error('请输入机构负责人')
            return false;
        }
        if (!this.form.orgPhone) {
            ElMessage.error('请输入联系方式')
            return false;
        }
        //校验手机号格式
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(this.form.orgPhone)) {
            ElMessage.error('联系方式格式错误')
            return false;
        }
        if (!this.form.trainProgramIdForm || this.form.trainProgramIdForm.length == 0) {
            ElMessage.error('请选择培训项目')
            return false;
        }
        if (!this.form.schoolLicense) {
            ElMessage.error('请选择是否有办学许可证')
            return false;
        }
        if (!this.form.memberNum) {
            ElMessage.error('请输入会员人数')
            return false;
        }
        if (!this.form.coachNum) {
            ElMessage.error('请输入教练人数')
            return false;
        }
        if (!this.form.trainPlaceType) {
            ElMessage.error('请选择培训场地类型')
            return false;
        }
        if (!this.form.orgArea) {
            ElMessage.error('请输入机构总面积')
            return false;
        }
        //将培训项目转为字符串

        this.form.trainProgramId = this.form.trainProgramIdForm.join(",")
        let _this = this
        saveOrgInfo(this.form).then(response => {
            console.log(response.code)
            if(response.code == 200){
                this.form={};

                ElMessage.success('提交成功');

                setTimeout(function () {
                    _this.$router.push('/')
                }, 1000)

            }else{
                ElMessage.error(response.msg);
            }


        });
    }
  }
}
</script>
<style scoped>

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 5px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


.imgx {
  margin-left: -25px;
}

.jindu div {
  margin-left: 20px;
}

.hang {
  margin-left: 150px;
  color: black;
  font-size: 16px;
}

.inputs {
  width: 40%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 15px;
  margin-left: 5px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 37%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.buttons3 {
  cursor: pointer;
  position: relative;
  left: 20%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 51, 51, 1);
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FF3333;
  text-align: center;
  line-height: 45px;
}

:deep(.el-p .el-input__wrapper){
    width: 100% !important;
}
</style>
